import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import starIcon from '../../assets/icons/star.svg';
import {OfferIcon, Star} from './LandingPanel.style';

export const SpecialOfferIcon = props => {
  const {black} = props;
  return (
    <OfferIcon black={black}>
      <Star black={!black}>
        <Isvg src={starIcon} />
      </Star>
    </OfferIcon>
  );
};

SpecialOfferIcon.propTypes = {
  black: PropTypes.bool
};



// WEBPACK FOOTER //
// ./containers/LightHomePage/SpecialOfferIcon.js